import { AppContextProvider } from 'lincd-server-utils/components/AppContext';
import { initFrontend } from 'lincd-server-utils/utils/Frontend';
import React, { startTransition } from 'react';
import { hydrateRoot } from 'react-dom/client';
import { ErrorBoundary } from 'react-error-boundary';
import { BrowserRouter } from 'react-router-dom';
import App from './App.js';
import './config-frontend';

function ErrorFallback({ error }: { error: Error }) {
  return (
    <div role="alert">
      <p>Something went wrong:</p>
      <pre>{error.message}</pre>
    </div>
  );
}
// console.log(renderToString(<React.StrictMode>
//   <ErrorBoundary FallbackComponent={ErrorFallback}>
//     <BrowserRouter>
//       <AppContextProvider
//         assets={window['assetManifest']}
//         requestLD={document.getElementById('request-ld')?.innerText}
//         requestObject={document.getElementById('request-json')?.innerText}
//       >
//         <App />
//       </AppContextProvider>
//     </BrowserRouter>
//   </ErrorBoundary>
// </React.StrictMode>));

console.log('Hydration starting...');
initFrontend().then(() => {
  startTransition(() => {
    hydrateRoot(
      document.getElementById('root'),
      <React.StrictMode>
        <ErrorBoundary FallbackComponent={ErrorFallback}>
          <BrowserRouter
            future={{
              v7_startTransition: true,
              v7_relativeSplatPath: true,
            }}
          >
            <AppContextProvider
              assets={window['assetManifest']}
              requestLD={document.getElementById('request-ld')?.innerText}
              requestObject={document.getElementById('request-json')?.innerText}
            >
              <App />
            </AppContextProvider>
          </BrowserRouter>
        </ErrorBoundary>
      </React.StrictMode>,
      {
        onRecoverableError: (error) => {
          console.error('Recoverable error during hydration:', error);
          // Optionally send the error to a monitoring service
        },
      }
    );
    console.log('Hydration completed.');
  });
});
